










import { Vue, Component } from 'vue-property-decorator';
import EditarVehiculosBase from './EditarVehiculosBase.vue';

@Component({
  components: { EditarVehiculosBase },
})
export default class EditarVehiculoPantalla extends Vue {}
